import Cookies from 'js-cookie'

//const TokenKey = 'X-JWT-SUPTOKEN'

export function getCookie(TokenKey) {
  return Cookies.get(TokenKey)
}

export function setCookie(TokenKey,token) {
  console.log("name===",TokenKey,token);
  return Cookies.set(TokenKey, token)
}

export function removeCookie(TokenKey) {
  return Cookies.remove(TokenKey)
}
